import React, { useState, useRef, useEffect } from 'react';
import { routeConfig } from './routeConfig';

function DockSidebar({ user, onTabOpen, onLogout, isExpanded, onHover, onLeave }) {
    const [showProfileMenu, setShowProfileMenu] = useState(false);
    const profileRef = useRef(null);

    const availableRoutes = Object.values(routeConfig).filter(route =>
        route.icon && route.allowedRoles.includes(user.role)
    );

    useEffect(() => {
        function handleClickOutside(event) {
            if (profileRef.current && !profileRef.current.contains(event.target)) {
                setShowProfileMenu(false);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, [profileRef]);

    return (
        <aside 
            className="dock-sidebar" 
            onMouseEnter={() => !showProfileMenu && onHover && onHover()} 
            onMouseLeave={() => !showProfileMenu && onLeave && onLeave()}
        >
            <div className="sidebar-header-reborn">
                <img src={user.settings?.clinic_logo || '/logo192.png'} alt="Logo" className="sidebar-logo" />
            </div>
            <nav className="sidebar-nav-reborn">
                {availableRoutes.map(route => (
                    <button key={route.id} className="nav-item-reborn" title={!isExpanded ? route.title : ''} onClick={() => onTabOpen(route.id)}>
                        <span className="nav-icon">{route.icon}</span>
                        <span className="nav-text">{route.title}</span>
                    </button>
                ))}
            </nav>
            <div className="sidebar-footer-reborn" ref={profileRef}>
                {showProfileMenu && (
                    <div className="profile-dropdown">
                        <div className="profile-menu-header">
                            <strong>{user.full_name}</strong>
                            <small style={{display: 'block', color: '#858796'}}>{user.role === 'admin' ? 'Yönetici' : (user.role === 'doctor' ? 'Doktor' : 'Personel')}</small>
                        </div>
                        <button className="profile-menu-item" onClick={() => { onTabOpen('profile'); setShowProfileMenu(false); }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '10px'}}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg> Profilim
                        </button>
                        {user.role === 'admin' && (
                            <button className="profile-menu-item" onClick={() => { onTabOpen('settings'); setShowProfileMenu(false); }}>
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '10px'}}><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg> Ayarlar
                            </button>
                        )}
                        <div style={{borderTop: '1px solid #eaecf4', margin: '5px 0'}}></div>
                        <button className="profile-menu-item" onClick={onLogout} style={{color: '#e74a3b'}}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: '10px'}}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg> Çıkış Yap
                        </button>
                    </div>
                )}
                <div className="user-info-reborn" onClick={() => setShowProfileMenu(!showProfileMenu)}>
                    <img
                        src={user.profile_image || 'https://zertucha.com/demos/dentis/uploads/logo_1770576275.png'}
                        alt="Profil"
                    />
                    <div className="user-details">
                        <strong>{user.full_name}</strong>
                        <small>{user.role}</small>
                    </div>
                </div>
            </div>
        </aside>
    );
}

export default DockSidebar;